export const Localization = {
    toolbar: {
        searchTooltip: 'Chercher',
        searchPlaceholder: 'Chercher',
        exportTitle: 'Telecharger',
        exportName: 'CSV - Excel',
        nRowsSelected: '{0} lignes sélectionnées'
    },
    header: {
        actions: 'Actes'
    },
    body: {
        addTooltip: 'Ajouter',
        deleteTooltip: 'Supprimer',
        editTooltip: 'Éditer',
        emptyDataSourceMessage: 'Aucun élément à afficher.',
        editRow: {
            deleteText: 'Êtes-vous sûr de bien vouloir supprimer cet élément?',
            cancelTooltip: 'Annuler',
            saveTooltip: 'Enregistrer'
        }
    },
    pagination: {
        firstTooltip: 'Première page',
        lastTooltip: 'Dernière page',
        previousTooltip: 'Page précédente',
        nextTooltip: 'Page suivante',
        labelRowsSelect: 'lignes',
        labelDisplayedRows: '{from}-{to} sur {count}'
    }
}

export const getDelimiter = () => {
    var language = window.navigator.userLanguage || window.navigator.language;
    if (language.toUpperCase().includes('FR')) {
        return ';'
    } else {
        return ','
    }
}